<template>
    <div class="relative mb-2" data-cy="container_history_delivery_detail">
        <div>
            <img class="w-32 rounded-lg mx-auto border" data-cy="img_history_delivery_campaign" :src="serialModel.fullImageUrl">
        </div>
        <div class="w-4/5 font-bold text-center text-16 text-a-blue-2140a6 py-2.5 mx-auto" data-cy="text_history_delivery_campaign_name">
            {{serialModel.name}}
        </div>
        <div class="flex items-center justify-center gap-3 text-center text-12 text-a-black-000926 pt-1 pb-2"
            v-if="serialModel.parcelNo" data-cy="container_history_delivery_parcel">
            <div data-cy="text_history_delivery_parcel_number">{{lbl.history.parcel_number}} {{serialModel.parcelNo}}</div>
            <div class="flex items-center justify-center gap-2 text-12 text-a-blue-2140a6 border border-a-blue-2140a6 rounded-sm px-2 py-0.5"
                data-cy="btn_history_delivery_copy_parcel"
                v-clipboard:copy="serialModel.parcelNo"
                v-clipboard:success="onCopyCode">
                <div><img src="@/assets/icon/ic-copy.svg" data-cy="icon_history_delivery_copy" /></div>
                <div data-cy="text_history_delivery_copy">{{lbl.history.copy}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import LocaleMixin from '@/mixin/LocaleMixin.js';
export default {
    name: "DeliveryDetail",
    mixins: [LocaleMixin],
    props: {
        serialModel: Object,
    },
    created: function(){
        console.log('this.serialModel', this.serialModel)
    },
    methods: {
        onCopyCode: function(event){
            this.$emit('onCopy');
            console.log('copied', event.text);
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/image.scss";
</style>
